<template>
  <div class="blood-oxygen-report-print-page">
    <div v-if="reportDetailModel" class="single-blood-oxygen-report" ref="printContent">
      <!-- 屏幕显示的头部信息 -->
      <div class="screen-header">
        <img class="single-blood-oxygen-report-logo" :src="reportDetailModel.sopReportLogo"
          :style="{ width: reportDetailModel.xyReportTemplateType === 3 ? '166px' : '66px' }"
          v-if="reportDetailModel.sopReportLogo != null && reportDetailModel.sopReportLogo != ''">
        <p class="single-blood-oxygen-report-title">{{ reportDetailModel.sopReportHeaders || "" }}</p>
        <p class="single-blood-oxygen-report-subtitle">{{ reportDetailModel.sopReportSubTitle || "" }}</p>
        <div class="single-blood-oxygen-report-button-container" :class="useClassWithDifferentBrower()">
          <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onShare">分享</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onDownloadPNG">下载PNG</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onDownloadPDF">下载PDF</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onPrint">打印</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onClose">关闭</button>
        </div>
        <section-time :reportDetailModel="reportDetailModel" v-if="showBasicInfo"></section-time>
        <section-user-info :reportDetailModel="reportDetailModel" @onEditUserInfoSucceed="onEditUserInfoSucceed" v-if="showBasicInfo">
        </section-user-info>
      </div>

      <!-- 第一页内容包装器 -->
      <div class="print-page-1" :class="{ 'need-page-break': showSecondPage }" v-if="showFirstPage">
        <div class="print-header-for-page">
          <section-report-header-print 
            :reportDetailModel="reportDetailModel" 
            :pageSpecificSubtitle="reportDetailModel.printFirstPageTitle">
          </section-report-header-print>
        </div>
        <section-blood-oxygen 
          class="first-content-section" 
          :reportDetailModel="reportDetailModel"
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧统计')"
        ></section-blood-oxygen>
        <section-oxygen-minus-table 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('氧减统计')" 
          :reportDetailModel="reportDetailModel"
        ></section-oxygen-minus-table>
        <section-trend-chart-template1 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧趋势')"
          :reportDetailModel="reportDetailModel"
        ></section-trend-chart-template1>
        <section-pulse 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('脉率统计')"
          :reportDetailModel="reportDetailModel"
        ></section-pulse>
        <section-pulse-trend-chart 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('脉率趋势图')"
          :reportDetailModel="reportDetailModel"
        ></section-pulse-trend-chart>
        <section-oxgen-monitoring-overview 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧监测综述')"
          :reportDetailModel="reportDetailModel" 
          @onEditSuggestionSucceed="onEditSuggestionSucceed"
        ></section-oxgen-monitoring-overview>
      </div>

      <!-- 第二页内容包装器 -->
      <div class="print-page-2" v-if="showSecondPage">
        <div class="print-header-for-page">
          <section-report-header-print 
            :reportDetailModel="reportDetailModel" 
            :pageSpecificSubtitle="reportDetailModel.printSecondPageTitle">
          </section-report-header-print>
        </div>
        <!-- 睡眠分期统计 -->
        <div class="single-blood-oxygen-report-section sleep-content-section" v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况')">
          <section-period-table :reportDetailModel="reportDetailModel"></section-period-table>
          <div class="single-blood-oxygen-report-section-chart">
            <section-period-chart :reportDetailModel="reportDetailModel"></section-period-chart>
            <section-time-period-chart :reportDetailModel="reportDetailModel"></section-time-period-chart>
          </div>
        </div>
        <section-trend-sleep-chart 
          v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠分期图')"
          :reportDetailModel="reportDetailModel"
        ></section-trend-sleep-chart>
        <section-sleep-monitoring-overview 
          v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠监测综述')"
          :reportDetailModel="reportDetailModel" 
          @onEditSuggestionSucceed="onEditSuggestionSucceed"
        ></section-sleep-monitoring-overview>
        <section-suggestion 
          v-if="reportDetailModel.sleepStructureModuleConfig.includes('监测意见与建议')"
          :reportDetailModel="reportDetailModel" 
          @onEditSuggestionSucceed="onEditSuggestionSucceed"
        ></section-suggestion>
      </div>

      <!-- 报告底部 -->
      <section-report-bottom v-if="reportDetailModel.isShowIntended()"></section-report-bottom>
    </div>
    
    <div v-else class="loading-content">
      <p>正在加载报告数据...</p>
    </div>
  </div>
</template>

<script>
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/key-value-unit/key-value-unit-blood-oxygen-report.vue";
import SectionTime from "@c/report-detail/single-blood-oxygen-report/new-section/section-time.vue";
import SectionUserInfo from "@c/report-detail/single-blood-oxygen-report/new-section/section-user-info.vue";
import SectionReportHeaderPrint from "@c/report-detail/single-blood-oxygen-report/new-section/section-report-header-print.vue";
import SectionBloodOxygen from "@c/report-detail/single-blood-oxygen-report/new-section/section-blood-oxygen.vue";
import SectionOxygenMinusTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxygen-minus-table.vue";
import SectionPulse from "@c/report-detail/single-blood-oxygen-report/new-section/section-pulse.vue";
import SectionHrv from "@c/report-detail/single-blood-oxygen-report/section-hrv.vue";
import SectionPeriod from "@c/report-detail/single-blood-oxygen-report/section-period.vue";
import SectionTrendChart from "@c/report-detail/single-blood-oxygen-report/section-trend-chart.vue";
import SectionTrendChartTemplate1 from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-chart-template1.vue";
import SectionBloodOxygenTable from "@c/report-detail/single-blood-oxygen-report/section-blood-oxygen-table.vue";
import SectionBloodOxygenChart from "@c/report-detail/single-blood-oxygen-report/section-blood-oxygen-chart.vue";
import SectionOxygenMinusEventTable from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-event-table.vue";
import SectionOxygenMinusEventChart from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-event-chart.vue";
import SectionOxygenMinusTimeTable from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-time-table.vue";
import SectionOxygenMinusTimeChart from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-time-chart.vue";
import SectionPeriodTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-period-table.vue";
import SectionPeriodChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-period-chart.vue";
import SectionTimePeriodChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-time-period-chart.vue";
import SectionSuggestion from "@c/report-detail/single-blood-oxygen-report/new-section/section-suggestion.vue";
import SectionOxgenMonitoringOverview from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxgen-monitoring-overview.vue";
import SectionSleepMonitoringOverview from "@c/report-detail/single-blood-oxygen-report/new-section/section-sleep-monitoring-overview.vue";
import SectionTrendSleepChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-sleep-chart.vue";
import SectionPulseTrendChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-pulse-trend-chart.vue";
import SectionReportBottom from "@c/report-detail/single-blood-oxygen-report/section-report-bottom.vue";
import { ReportDetailModel } from "@c/report-detail/single-blood-oxygen-report/report-detail-model.js";
import { ReportPreviewTool } from "@js/report-preview-tool.js";
import html2canvas from "html2canvas";
import { DateTool } from "@js/date-tool.js";
import deviceTool from "@js/deviceTool.js";
import appHandler from "@js/appHandler.js"
import { MessageBox } from 'element-ui';

export default {
  name: 'BloodOxygenReportPrint',
  
  components: {
    KeyValueUnit,
    SectionTime,
    SectionUserInfo,
    SectionBloodOxygen,
    SectionOxygenMinusTable,
    SectionHrv,
    SectionPulse,
    SectionPeriod,
    SectionTrendChart,
    SectionTrendChartTemplate1,
    SectionBloodOxygenTable,
    SectionBloodOxygenChart,
    SectionOxygenMinusEventTable,
    SectionOxygenMinusEventChart,
    SectionOxygenMinusTimeTable,
    SectionOxygenMinusTimeChart,
    SectionPeriodTable,
    SectionPeriodChart,
    SectionSuggestion,
    SectionReportBottom,
    SectionOxgenMonitoringOverview,
    SectionTimePeriodChart,
    SectionTrendSleepChart,
    SectionPulseTrendChart,
    SectionSleepMonitoringOverview,
    SectionReportHeaderPrint,
  },

  data() {
    return {
      reportDetailModel: undefined,
      autoPrint: false
    };
  },

  computed: {
    
    // 判断是否显示第一页（血氧相关内容）
    showFirstPage() {
      if (!this.reportDetailModel?.spo2PulseModuleConfig) return false;
      
      return this.reportDetailModel.spo2PulseModuleConfig.includes('血氧统计') || 
             this.reportDetailModel.spo2PulseModuleConfig.includes('氧减统计') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('血氧趋势') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('脉率统计') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('脉率趋势图') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('血氧监测综述');
    },
    
    // 判断是否显示第二页（睡眠相关内容）
    showSecondPage() {
      if (!this.reportDetailModel?.sleepStructureModuleConfig) return false;
      
      return this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况') ||
             this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠分期图') ||
             this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠监测综述') ||
             this.reportDetailModel.sleepStructureModuleConfig.includes('监测意见与建议');
    },

    // 判断是否显示基本信息模块（时间和用户信息）
    showBasicInfo() {
      const spo2HasBasicInfo = this.reportDetailModel?.spo2PulseModuleConfig?.includes('基本信息');
      const sleepHasBasicInfo = this.reportDetailModel?.sleepStructureModuleConfig?.includes('基本信息');
      
      return spo2HasBasicInfo || sleepHasBasicInfo;
    }
  },

  async created() {
    // 获取URL参数
    const query = this.$route.query;
    this.autoPrint = query.autoPrint === 'true';
    
    console.log('BloodOxygenReportPrint created, autoPrint:', this.autoPrint);
    
    // 加载报告数据
    await this.loadReportData();
  },

  methods: {
    async loadReportData() {
      console.log('loadReportData called');
      
      try {
        // 从OSS获取预览数据
        console.log('开始从OSS获取预览数据');
        const ossResponse = await this.$api.getBloodOxygenReportPreviewData();
        // 如果API返回的是response.data格式，直接使用；如果已经处理过，直接使用response
        const previewData = ossResponse;
        
        console.log('成功获取OSS预览数据:', previewData);
        
        if (!previewData) {
          throw new Error('OSS返回的预览数据为空');
        }
        
        if (!previewData.reportDetail) {
          throw new Error('OSS预览数据中缺少reportDetail字段');
        }
        
        if (!previewData.reportUser) {
          throw new Error('OSS预览数据中缺少reportUser字段');
        }
        
        // 检查必要的全局函数是否可用
        if (typeof window.placeholderText !== 'function') {
          console.warn('placeholderText函数不可用，尝试定义备用函数');
          window.placeholderText = function(rawValue, unitText = "") {
            if (!rawValue) {
              return "-";
            } else {
              const finalUnitText = unitText ? ` ${unitText}` : "";
              return `${rawValue}${finalUnitText}`;
            }
          };
        }
        
        // 检查findKey函数是否可用
        if (typeof window.findKey !== 'function') {
          console.warn('findKey函数不可用，尝试定义备用函数');
          window.findKey = function(obj, value, compare = (a, b) => a === b) {
            return Object.keys(obj).find((k) => compare(obj[k], value));
          };
        }
        
        console.log('开始创建ReportDetailModel');
        const reportDetailModel = new ReportDetailModel(previewData);
        
        // 从URL查询参数获取覆盖值
        const query = this.$route.query;
      

        if (query.sopReportLogo) {
          reportDetailModel.sopReportLogo = decodeURIComponent(query.sopReportLogo);
          
        }
        if (query.sopReportHeaders) {
          reportDetailModel.sopReportHeaders = decodeURIComponent(query.sopReportHeaders);
          
        }
        if (query.sopReportSubTitle) {
          reportDetailModel.sopReportSubTitle = decodeURIComponent(query.sopReportSubTitle);
         
        }
        if (query.sopReportSubTitle) {
          reportDetailModel.printFirstPageTitle = decodeURIComponent(query.spo2PulseSecondaryTitle);
         
        }
        if (query.sopReportSubTitle) {
          reportDetailModel.printSecondPageTitle = decodeURIComponent(query.sleepStructureSecondaryTitle);
         
        }
        
        // 从URL参数获取模块配置
        if (query.sleepStructureModuleConfig) {
          try {
            reportDetailModel.sleepStructureModuleConfig = JSON.parse(decodeURIComponent(query.sleepStructureModuleConfig));
            console.log('Overridden sleepStructureModuleConfig with:', reportDetailModel.sleepStructureModuleConfig);
          } catch (error) {
            console.error('解析sleepStructureModuleConfig失败:', error);
          }
        }
        
        if (query.spo2PulseModuleConfig) {
          try {
            reportDetailModel.spo2PulseModuleConfig = JSON.parse(decodeURIComponent(query.spo2PulseModuleConfig));
            console.log('Overridden spo2PulseModuleConfig with:', reportDetailModel.spo2PulseModuleConfig);
          } catch (error) {
            console.error('解析spo2PulseModuleConfig失败:', error);
          }
        }
        
        this.reportDetailModel = reportDetailModel;
        console.log('ReportDetailModel创建完成 (with potential overrides):', this.reportDetailModel);
        
        // 如果是自动打印模式，等待DOM更新后自动打印
        if (this.autoPrint) {
          console.log('自动打印模式，准备打印');
          this.$nextTick(() => {
            setTimeout(() => {
              window.print();
            }, 1500); // 延迟1.5秒确保所有内容都已渲染
          });
        }
        
      } catch (error) {
        console.error('加载报告数据或应用覆盖失败:', error);
        console.error('错误堆栈:', error.stack);
        this.$toast?.showRed("报告数据加载失败: " + error.message);
      }
    },

    onDownloadPNG() {
      let createMillisecondTimestamp = DateTool.strToMillisecondTimestamp(this.reportDetailModel.startTimeStr)
      let createTimeStr = DateTool.millisecondTimestampToStr(createMillisecondTimestamp, "M月D日 h：m")
      html2canvas(this.$refs.printContent, {
        useCORS: true,
      }).then((canvas) => {
        var imgData = canvas.toDataURL("image/jpeg");
        if (deviceTool.getDeviceType() === "Android") {
          appHandler.sendMsg({
            path: this.$router.history.current.path,
            origin: "DownloadPNG",
            data: {
              name: this.reportDetailModel.nameStr,
              createTime: createTimeStr,
              imgData: imgData
            }
          })
        } else {
          ReportPreviewTool.downloadImageData(
            this.reportDetailModel.nameStr,
            createTimeStr,
            imgData
          );
        }
      });
    },

    async onDownloadPDF() {
      this.$toast?.showRed("打印页面模式下不支持下载PDF");
    },

    onPrint() {
      window.print();
    },

    async onShare() {
      this.$toast?.showRed("打印页面模式下不支持分享");
    },

    onClose() {
      window.close();
    },

    async onEditSuggestionSucceed() {
      this.$toast?.showGreen("编辑成功");
    },

    async onEditUserInfoSucceed() {
      this.$toast?.showGreen("编辑成功");
    },

    useClassWithDifferentBrower() {
      const browserType = deviceTool.getBrowserType()
      if (browserType === 'Safari') {
        return 'single-blood-oxygen-report-button-container-Safari-no-print'
      } else {
        return ''
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.blood-oxygen-report-print-page {
  min-height: 100vh;
  background-color: white;
  padding: 0;
  margin: 0;
}

.single-blood-oxygen-report {
  width: 1050px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 20px 40px 10px;
  
  .single-blood-oxygen-report-section-chart{
    display: flex;
    justify-content: space-between;
  }

  &-logo {
    height: 66px;
    width: 66px;
    position: absolute;
  }

  &-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    height: 24px;
    display: flex;
    justify-content: center;
  }

  &-subtitle {
    color: black;
    font-size: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }

  &-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 44px;
    margin-bottom: 30px;

    &-item {
      color: white;
      background-color: #325FAC;
      border-radius: 4px;
      width: 88px;
      height: 32px;
      margin-left: 20px;
      border: none;
      cursor: pointer;
      
      &:hover {
        background-color: #2a4d8a;
      }
    }
  }

  &-section-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    line-height: 73px;
    width: 100%;
  }

  &-section {
    display: flex;
  }

  // 打印页眉 - 默认隐藏
  .print-header-for-page {
    display: none;
  }

  // 屏幕显示的头部信息 - 默认显示
  .screen-header {
    display: block;
  }
}

.loading-content {
  text-align: center;
  padding: 50px;
  color: #666;
  font-size: 16px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  
  .blood-oxygen-report-print-page {
    background: white !important;
  }
  
  .single-blood-oxygen-report {
    width: 100% !important;
    max-width: none !important;
    padding: 0 !important;
    
    .print-header-for-page {
      display: block !important;
      padding-bottom: 20px;
    }

    .screen-header {
      display: none !important;
    }

    .print-page-1 {
      min-height: auto !important;
      padding-top: 5mm;
      
      &.need-page-break {
        page-break-after: always !important;
        break-after: page !important;
      }
    }
    
    .print-page-2 {
      width: 100% !important;
      box-sizing: border-box !important;
      padding-top: 5mm;
    }
    
    .first-content-section {
      margin-top: 0 !important;
    }
    
    .sleep-content-section {
      margin-top: 0 !important;
      width: 100% !important;
    }
    
    .single-blood-oxygen-report-section-chart {
      display: flex !important;
      justify-content: space-between !important;
      width: 100% !important;
      box-sizing: border-box !important;
      gap: 5px !important;
      
      > * {
        flex: 1 !important;
        max-width: 49% !important;
        min-width: 0 !important;
      }
    }
  }

  ::v-deep .sleep-pie-chart {
    width: 100% !important;
    min-width: 260px !important;
    height: 220px !important;
  }

  .single-blood-oxygen-report-button-container-Safari-no-print {
    height: 40px;
    margin: 0px;
  }

  .noPrint {
    display: none !important;
  }
}
</style> 